[
{
"hue-value": 360,
"color-title": "Red",
"color-text": "Used to create urgency, passion, and energy. In marketing, it is widely applied in sales, 'call-to-action' buttons, and fast-food branding to stimulate appetite and encourage quick decisions.",
"color-curiosidade": "Red was the first color humans mastered in painting. The earliest known artworks were created using red ochre on cave walls over 40,000 years ago." 
},
{
"hue-value": 40,
"color-title": "Orange",
"color-text": "Conveys creativity, youthfulness, and enthusiasm. In color theory, it is used to suggest innovation, accessibility, and a friendly tone without the direct aggression of red. Common in entertainment and children's technology brands.",
"color-curiosidade": "Before the late 15th century, the color orange had no specific name in Europe; it was simply called 'yellow-red' until the arrival and popularization of the fruit of the same name." 
},
{
"hue-value": 80,
"color-title": "Yellow-Green (Chartreuse)",
"color-text": "Associated with vitality, rapid growth, and acidity. In art and modern design, it is often used as a vibrant accent color to represent freshness, renewable energy, or a touch of eccentricity and innovation.",
"color-curiosidade": "The name 'Chartreuse' comes from a French liqueur created by Carthusian monks in 1764, whose top-secret recipe naturally results in this vibrant hue."
},
{
"hue-value": 120,
"color-title": "Green",
"color-text": "Represents health, nature, tranquility, and wealth. In the global market, it is the unanimous choice for eco-friendly and organic products as well as financial institutions, as it conveys stability and harmony.",
"color-curiosidade": "During the Victorian era, a pigment known as 'Paris Green' was extremely popular for clothing and wallpaper, yet it was lethal due to its high arsenic content." 
},
{
"hue-value": 160,
"color-title": "Cyan & Aqua",
"color-text": "Evokes clarity, cleanliness, and freshness. Widely used in healthcare, pharmaceuticals, technology, and hygiene products to convey sterility, purity, and clinical modernity.",
"color-curiosidade": "Cyan is one of the subtractive primary colors (the 'C' in the CMYK system) and serves as a fundamental pillar of modern printing, enabling the creation of almost all other colors on paper." 
},
{
"hue-value": 200,
"color-title": "Sky Blue (Azure)",
"color-text": "Inspires feelings of trust, security, communication, and calm. It is the dominant color in the technology and aviation sectors—and especially on social media—because it creates a welcoming, transparent, and non-intrusive environment.",
"color-curiosidade": "Various sociological studies indicate that blue is the favorite color of the majority of the world's population, regardless of gender, culture, or age." 
},
{
"hue-value": 240,
"color-title": "Deep Blue",
"color-text": "Symbolizes wisdom, professionalism, power, and loyalty. Traditional corporate brands, banks, law firms, and government institutions use this shade to inspire a sense of utmost seriousness and stability.",
"color-curiosidade": "In Renaissance art history, the 'ultramarine blue' pigment was made from the semi-precious stone lapis lazuli and was sometimes more expensive than gold, reserved only for the most important figures in paintings." 
},
{
"hue-value": 280,
"color-title": "Purple & Violet",
"color-text": "Linked to luxury, mystery, spirituality, and sophistication. It is frequently used in beauty products, premium items, fine chocolates, and brands focused on imagination and abstract creativity.",
"color-curiosidade": "In ancient Rome and Greece, purple dye ('Tyrian purple') was extracted drop by drop from thousands of small, decomposing sea snails, making the color so expensive that only emperors and royalty could wear it." 
},
{
"hue-value": 320,
"color-title": "Magenta",
"color-text": "Expresses boldness, a break from convention, and emotional energy. In contemporary design, it is used by brands that want to stand out from the competition as modern, rebellious, creative, or youth-oriented.",
"color-curiosidade": "Magenta is an 'extraspectral color.' This means it does not have its own wavelength in the light spectrum; it is an illusion created by our brain when our eyes capture red and blue light simultaneously, without the presence of green light." 
}
]